import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image1 from "../../../../assets/images/Blog50/image1.png";
import image7 from "../../../../assets/images/Blog50/image7.png";
import image3 from "../../../../assets/images/Blog50/image3.png";
import image6 from "../../../../assets/images/Blog50/image6.png";
import image10 from "../../../../assets/images/Blog50/image10.png";
import image5 from "../../../../assets/images/Blog50/image5.png";
import image46 from "../../../../assets/images/Blog50/image46.png";
import image47 from "../../../../assets/images/Blog50/image47.png";
import image49 from "../../../../assets/images/Blog50/image49.png";
import image42 from "../../../../assets/images/Blog50/image42.png";
import image20 from "../../../../assets/images/Blog50/image20.png";
import image19 from "../../../../assets/images/Blog50/image19.png";

import image22 from "../../../../assets/images/Blog50/image22.png";
import image35 from "../../../../assets/images/Blog50/image35.png";
import image38 from "../../../../assets/images/Blog50/image38.png";
import image15 from "../../../../assets/images/Blog50/image15.png";
import image78 from "../../../../assets/images/Blog50/image78.png";
import image76 from "../../../../assets/images/Blog50/image76.png";
import BlogImagePopper from "./BlogImageLarge";

const Blog50 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – January 5th, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedBoldText ">Power Reasserts Itself, Liquidity Returns, and Markets Face Their First Real Test of the Year</p>
        <p>
          The new year began quietly, but the calm did not last long. Thin liquidity and incomplete participation gave way to one sharply manic session, a reminder that geopolitical nudges still have
          the power to destabilise otherwise orderly price action. With many desks not yet fully engaged, flows rather than conviction dictated movement.
        </p>
        <p>
          Beneath the surface, however, the tone is already shifting. This is not simply a question of risk appetite returning after the holidays. Energy, resources, and power pricing are beginning to
          reconnect with rates, currencies, and equities. The first week of 2026 is less about direction and more about <span className="highlightedText">where stress is quietly building.</span>
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Power Prices Are the Real Macro Lever</p>
              <p>
                Equities enter 2026 holding structure rather than accelerating. Indices remain supported, not because optimism is surging, but because forced selling remains absent and liquidity is
                still cushioning downside. This continues to look like persistence rather than expansion.
              </p>
              <p>
                What is increasingly clear is that <span className="highlightedText">energy sits at the centre of the macro framework.</span> The US produces vast amounts of oil, but the composition
                of that production matters more than the headline number. Domestic output continues to skew toward light, sweet crude, while refinery infrastructure remains configured for heavy, sour
                barrels.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt="US heavy crude problem."
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt="US heavy/light growth"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>This mismatch is structural, not cyclical, and it explains why geopolitics—particularly Venezuela—has returned so forcefully to the market narrative.</p>
              <p>
                Consensus positioning adds another layer of fragility. Expectations for continued US outperformance have become increasingly uniform, a condition that rarely breaks trends outright but
                often changes the character of price action.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt="consensual US outperformance"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>When agreement becomes comfortable, markets tend to drift—until they don’t.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Venezuela, the Petrodollar, and Control of Supply Chains</p>

              <p>
                The macro picture is clear: this is not simply about pumping more oil. It is about<span className="highlightedText"> who controls the flow, the pricing, and the settlement.</span>
              </p>
              <p>
                Venezuela holds one of the largest proven crude oil reserves globally, and a significant portion of its output has already been pre-sold to China and Russia in exchange for loans and
                political leverage.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt="proven crude oil reserves"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt="Venezuela oil history"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Any renegotiation of those arrangements has implications far beyond oil prices. Lower effective energy costs feed directly into lower inflation, lower rates, and a more supportive
                backdrop for US Treasuries and equities.
              </p>
              <p>This is where the petrodollar narrative quietly resurfaces.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt="Petrodollars back in town."
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The US retains a unique advantage: financing deficits in its own currency while maintaining influence over the world’s most critical commodity. With Venezuela representing roughly 18%
                of global oil reserves, influence over those flows could materially affect inflation dynamics and debt servicing pressures at a time when interest payments are already uncomfortably
                large.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image46}
                    alt="US interest rate payment risk"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image46)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Supportive, but Increasingly Fragile</p>
              <p>
                From a technical standpoint, market structure remains intact. Major indices continue to hold trend support, pullbacks have been contained, and consolidation has occurred near highs
                rather than after breakdowns. That said, momentum has slowed materially, and price action feels more reactive to disappointment than it did late last year.
              </p>
              <p>
                Sentiment captures that tension well. Indicators sit close to neutral—neither pessimistic enough to suggest capitulation nor complacent enough to justify aggressive risk-taking. This
                is typically the zone where markets become more sensitive to shocks rather than resilient to them.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image47}
                    alt="VIX risk. on but...."
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image47)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Groupthink risk is increasing. Expectations appear clustered around the idea of “some upside, but not too much,” a consensus that often masks the potential for sharper swings in both
                directions once liquidity fully returns and positioning is tested.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt="consensual US outperformance"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Volatility remains compressed, which historically supports equity drift, but timing matters. Periods of suppressed volatility during thin participation often delay adjustment rather
                than eliminate it. With geopolitical variables already active, volatility feels stored rather than extinguished.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image49}
                    alt="Realised vol smashed down too"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image49)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Overall, positioning and sentiment suggest outcomes may become increasingly asymmetric around disappointment rather than delivering broad-based upside expansion.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Liquidity Stress, Commodities Signal, and Early-Year Reality</p>
              <p>
                Markets opened the year quietly but were interrupted by a sharp, manic session that cut through otherwise thin holiday liquidity. With participation still incomplete, flows and
                positioning dictated price action more than conviction. Beneath the surface, however, several stress points became more visible as the calendar turned.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br>Data through the week remained limited, but early signals pointed to softer manufacturing momentum, consistent with typical year-end distortions. With many participants
                    not fully back at desks, the absence of forced selling mattered more than the data itself. Liquidity conditions masked underlying fragility rather than resolving it.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image42}
                        alt="us manu weak pmi"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image42)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br></br>China remained a central variable through commodity channels rather than macro releases. Continued physical demand pressures remained evident, particularly in metals, with
                    China increasingly operating outside Western paper markets. This divergence continues to challenge traditional price discovery mechanisms.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image20}
                        alt="China silver ban for real"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image20)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br></br>Equity support has continued to come from underlying fundamentals rather than indiscriminate valuation expansion, with earnings remaining central to market structure since
                    the October 2022 lows.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities: </span>
                    <br></br>Real assets continued to assert themselves quietly. Gold maintained its role as an alternative to long-dated bonds in an environment where fixed income offers limited
                    protection. Silver remained the standout, driven by physical tightness and supply constraints rather than speculative excess.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image19}
                      alt="real assets v financials overshoot"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image19)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image22}
                      alt="Tavi Costa Silver fundamentals"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image22)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br></br>Crypto price action is increasingly resembling consolidation rather than a reversal. Bitcoin held key levels, but positioning remains heavy above the market, suggesting
                    range-bound conditions until trapped exposure is worked through. Volatility remains contained, but conviction is being tested.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image35}
                      alt="BTC above $90k"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image35)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image38}
                      alt="BTC approaching heavy sell zone"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image38)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br></br>Energy remained capped by sentiment despite growing geopolitical optionality. Crude continues to respect a broader downtrend, but positioning has become increasingly
                    negative. It would not take much to trigger a reflexive move should the flow turn.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image15}
                        alt="oil downtrend"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image15)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                With the holiday period behind us, the first full trading week of the year brings a meaningful return of liquidity and participation. Markets will begin to test whether recent
                stability was structural or merely a function of thin volumes. While flows will still matter early in the week, several high-impact data points and policy signals have the potential to
                reset narratives quickly.
              </p>
              <p className="highlightedText">Monday, January 5</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S.: ISM Manufacturing PMI (Dec)</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: ISM Manufacturing Prices & Employment</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Construction Spending (MoM)</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Atlanta Fed GDPNow (Q4 Update)</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, January 6</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Eurozone: Services & Composite PMIs (Final)</p>
                </li>
                <li className="themesPointer">
                  <p>France & Germany: CPI / HICP (Dec)</p>
                </li>
                <li className="themesPointer">
                  <p>U.K.: Services PMI (Final)</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: S&P Global Services PMI (Final)</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Redbook Retail Sales</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: API Weekly Crude Oil Stocks</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, January 7</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S.: ADP Employment Change (Dec)</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: ISM Services PMI (Dec)</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: JOLTS Job Openings</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Crude Oil Inventories</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone: Retail Sales (Germany)</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, January 8</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.K.: Halifax House Price Index (Dec)</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Challenger Job Cuts</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Initial & Continuing Jobless Claims</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Trade Balance</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Productivity & Unit Labour Costs</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, January 9</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>China: CPI & PPI (Dec)</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Non-Farm Payrolls (Dec)</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Unemployment Rate & Average Hourly Earnings</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Participation Rate</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Michigan Consumer Sentiment & Inflation Expectations</p>
                </li>
              </ul>
              <div className="relatedImg">
                <img
                  src={image78}
                  alt="EW 050126"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image78)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: A Supported Market, With Fragility Beneath</p>
              <p>Markets begin the year supported, but not comfortable. Liquidity and structure are carrying risk assets, yet confidence in narratives is being quietly tested.</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br>Structure remains constructive, but upside is becoming increasingly selective rather than broad-based. This is not a market rewarding indiscriminate exposure.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>Gold continues to benefit from waning confidence in long-dated fixed income. Silver’s move remains structural,
                    driven by physical tightness, but near-term volatility should be expected as positioning resets.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Belief is being tested, not broken. Consolidation may persist, but volatility is likely before clarity emerges as trapped
                    positioning is worked through.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br>Liquidity remains abundant, but growth is less convincing. Debt dynamics, yield behaviour, and control of resources—not
                    policy soundbites—will shape conditions through 2026.
                  </p>
                </li>
              </ul>

              <p className="highlightedText">
                This still feels like a grind higher—until it doesn’t. Flows decide direction, but crowded trades unwind quietly before they unwind violently. Participate, but stay nimble.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image47}
                    alt="VIX risk. on but...."
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image47)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image49}
                    alt="Realised vol smashed down too"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image49)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image76}
                    alt="Dollar to pivot or not to pivot?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image76)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/19_lZLkWaq7pagYAQjI3brEp_BSLGkapRCDnKUNG-jQQ/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
        <hr className="divisionLine" />
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog50;
